import React, { useEffect, useState } from 'react';
import PanelShell from '../PanelShell';

const EqPanel = ({ nodeType, nodeId, data, onChange }) => {
  const [left, setLeft] = useState(data?.left || '');
  const [right, setRight] = useState(data?.right || '');
  useEffect(()=>{ setLeft(data?.left || ''); setRight(data?.right || ''); }, [data]);
  if (nodeType !== 'Eq') return null;
  const save=()=> onChange({ label:'Eq', left, right, Title:`${left} == ${right}` });
  return (
    <PanelShell title="Eşitlik (Eq)" onSave={save}>
      <label>Sol</label>
      <input value={left} onChange={e=>setLeft(e.target.value)} />
      <label>Sağ</label>
      <input value={right} onChange={e=>setRight(e.target.value)} />
    </PanelShell>
  );
};
export default EqPanel;
